function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ExcelDocument_svg__clip0_1818_35532)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.375 16.875h-8.75A.625.625 0 0110 16.25V3.75c0-.345.28-.625.625-.625h8.75c.345 0 .625.28.625.625v12.5c0 .345-.28.625-.625.625z",
  fill: "#ECEFF1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.125 6.875h-2.5a.625.625 0 010-1.25h2.5a.625.625 0 010 1.25zM13.125 9.375h-2.5a.625.625 0 010-1.25h2.5a.625.625 0 010 1.25zM13.125 11.875h-2.5a.625.625 0 010-1.25h2.5a.625.625 0 010 1.25zM13.125 14.375h-2.5a.625.625 0 010-1.25h2.5a.625.625 0 010 1.25zM16.875 6.875h-1.25a.625.625 0 010-1.25h1.25a.625.625 0 010 1.25zM16.875 9.375h-1.25a.625.625 0 010-1.25h1.25a.625.625 0 010 1.25zM16.875 11.875h-1.25a.625.625 0 010-1.25h1.25a.625.625 0 010 1.25zM16.875 14.375h-1.25a.625.625 0 010-1.25h1.25a.625.625 0 010 1.25z",
  fill: "#388E3C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.024.77a.614.614 0 00-.514-.133l-10 1.875a.623.623 0 00-.51.614v13.75c0 .3.214.559.51.614l10 1.875a.623.623 0 00.74-.614V1.25a.623.623 0 00-.226-.481z",
  fill: "#2E7D32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.595 12.09L6.62 9.83l1.999-2.57a.626.626 0 00-.987-.768l-1.85 2.38-1.56-1.783a.624.624 0 10-.94.822l1.718 1.966-1.743 2.24a.626.626 0 10.988.767l1.594-2.05 1.817 2.076a.62.62 0 00.881.06.624.624 0 00.06-.88z",
  fill: "#FAFAFA"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ExcelDocument_svg__clip0_1818_35532"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgExcelDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgExcelDocument;